import React from 'react';
import { formatCurrency } from '../../utils/Utils';

function RigaOrdine({ data }) {
    
    return (
        <tr>
            <td className='text-center'>{data.rigarif}</td>
            <td className='text-center'>{data.codprod}</td>
            <td>{data.desprod}</td>
            <td className='text-center'>{data.qta}</td>
            <td className="text-end">{formatCurrency(data.prezzo)}</td>
            <td className="text-end">{formatCurrency(data.totsconto)}</td>
            <td className="text-end">{formatCurrency(data.prezzo_scontato)}</td>
            <td className="text-end">{formatCurrency(data.importo_con_tasse)}</td>
        </tr>
    );
}

export default RigaOrdine;
